import { createContext, useContext } from 'react'

import { JourneyContextProps, JourneyScope } from './types'

const error = () => {
  throw Error('JourneyProvider not found')
}
export const JourneyContext = createContext<JourneyContextProps>({
  navigate: error,
  idle: error,
  end: error,
  endAll: error,
  goBack: error,
  isInProgress: false,
  hasParentTarget: () => false,
})

export function useJourneyContext() {
  return useContext<JourneyContextProps<JourneyScope>>(JourneyContext)
}

export function useJourneyScope(): Partial<JourneyScope> {
  const context = useJourneyContext()

  return context.active?.opts?.scope ?? {}
}
